module.exports = __webpack_public_path__ + "img/fahrradbox_start.e8efdfbc.jpg";